import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "textAlign", "label", "showEllipsis"];
import React from 'react';
import { StyledTD, StyledTDContent } from './TD.styled';
export function TD(_ref) {
  var children = _ref.children,
    _ref$textAlign = _ref.textAlign,
    textAlign = _ref$textAlign === void 0 ? 'left' : _ref$textAlign,
    label = _ref.label,
    _ref$showEllipsis = _ref.showEllipsis,
    showEllipsis = _ref$showEllipsis === void 0 ? true : _ref$showEllipsis,
    tdProps = _objectWithoutProperties(_ref, _excluded);
  var titleText = typeof children === 'string' ? children : '';
  return /*#__PURE__*/React.createElement(StyledTD, _extends({
    "data-label": label || '',
    textAlign: textAlign,
    showEllipsis: showEllipsis
  }, tdProps), /*#__PURE__*/React.createElement(StyledTDContent, {
    showEllipsis: showEllipsis,
    title: titleText
  }, children));
}